<template>
  <el-dialog
    title="服务商支付参数配置"
    :visible.sync="dialogVisible"
    @opened="dialogOpen"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="100px"
      size="small"
    >
      <el-form-item
        prop="userCode"
        label="支付方式"
      >
        <el-radio v-model="radio" label="0"  @change="changeHandler(0)">微信</el-radio>
        <el-radio v-model="radio" label="1"  @change="changeHandler(1)">支付宝</el-radio>
        <el-radio v-model="radio" label="2" @change="changeHandler(2)">乐刷</el-radio>
        <el-radio v-model="radio" label="3" @change="changeHandler(3)">随行付</el-radio>
        <el-radio v-model="radio" label="4" @change="changeHandler(4)">银盛</el-radio>
      </el-form-item>
      <el-form-item v-if="formEdit1"
        prop="wx_appId"
        label="appId"
      >
        <el-input v-model="form.wx_appId" :disabled="disabledStr1"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit2"
                    prop="wx_mchId"
                    label="mchId"
      >
        <el-input v-model="form.wx_mchId" :disabled="disabledStr2"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit3"
                                    prop="wx_api_key"
                                    label="API密钥"
    >
      <el-input v-model="form.wx_api_key" :disabled="disabledStr3"></el-input>
    </el-form-item>

      <el-form-item v-if="formEdit4"
                    prop="wx_appSecret"
                    label="appSecret"
      >
        <el-input v-model="form.wx_appSecret" :disabled="disabledStr4"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit5"
                    prop="wx_certificate_path"
                    label="证书路径"
      >
        <el-input v-model="form.wx_certificate_path" :disabled="disabledStr5"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit6"
                    prop="wx_apiv3_key"
                    label="apiV3密钥"
      >
        <el-input v-model="form.wx_apiv3_key" :disabled="disabledStr6"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit7"
                    prop="wx_certificate"
                    label="证书"
      >

        <el-input v-model="form.wx_certificate" style="display:none" ></el-input>
        <el-input v-model="form.wx_certificate_name" style="display:none" ></el-input>
        <el-upload
                ref="upload"
                :action="imgUrl"
                list-type="fileList"
                :limit=1
                :auto-upload="true"
                :file-list="fileList"
                :before-upload="handleBeforeUpload"
                :on-remove="handleRemove"
                :disabled="disabledStr7"
                :on-success="handlePictureCardPreview">
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>

      </el-form-item>

      <el-form-item v-if="formEdit8"
                    prop="wx_rate"
                    label="利率"
      >
        <el-input-number v-model="form.wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr8"></el-input-number>
      </el-form-item>

      <el-form-item v-if="formEdit9"
                    prop="zfb_appId"
                    label="appId"
      >
        <el-input v-model="form.zfb_appId" :disabled="disabledStr9"></el-input>
      </el-form-item>
        <el-form-item v-if="formEdit10"
                      prop="zfb_privateKey"
                      label="privateKey"
        >
          <el-input v-model="form.zfb_privateKey" :disabled="disabledStr10"></el-input>
        </el-form-item>
          <el-form-item v-if="formEdit11"
                        prop="zfb_publicKey"
                        label="publicKey"
          >
            <el-input v-model="form.zfb_publicKey" :disabled="disabledStr11"></el-input>
          </el-form-item>
            <el-form-item v-if="formEdit12"
                          prop="zfb_rate"
                          label="利率"
            >
              <el-input-number v-model="form.zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr12"></el-input-number>
            </el-form-item>

      <el-form-item v-if="formEdit13"
                    prop="zfb_applet_key"
                    label="小程序密钥"
      >
        <el-input v-model="form.zfb_applet_key" :disabled="disabledStr13"></el-input>
      </el-form-item>
      <el-form-item v-if="formEdit14"
                    prop="zfb_applet_appid"
                    label="小程序AppId"
      >
        <el-input v-model="form.zfb_applet_appid" :disabled="disabledStr14"></el-input>
      </el-form-item>
      <el-form-item v-if="formEdit15"
                    prop="zfb_pid"
                    label="支付宝pid"
      >
        <el-input v-model="form.zfb_pid" :disabled="disabledStr15"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit16"
                    prop="fy_wx_rate"
                    label="微信利率"
      >
        <el-input-number v-model="form.fy_wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr16"></el-input-number>
      </el-form-item>

      <el-form-item v-if="formEdit17"
                    prop="fy_zfb_rate"
                    label="支付宝利率"
      >
        <el-input-number v-model="form.fy_zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr17"></el-input-number>
      </el-form-item>

      <el-form-item v-if="formEdit18"
                    prop="fy_private_key"
                    label="乐刷私钥"
      >
        <el-input v-model="form.fy_private_key" :disabled="disabledStr18"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit19"
                    prop="fy_mechanism_coding"
                    label="乐刷机构编码"
      >
        <el-input v-model="form.fy_mechanism_coding" :disabled="disabledStr19"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit20"
                    prop="fy_order_code"
                    label="乐刷订单编码"
      >
        <el-input v-model="form.fy_order_code" :disabled="disabledStr20"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit21"
                    prop="sxf_wx_rate"
                    label="微信利率"
      >
        <el-input-number v-model="form.sxf_wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr21"></el-input-number>
      </el-form-item>

      <el-form-item v-if="formEdit22"
                    prop="sxf_zfb_rate"
                    label="支付宝利率"
      >
        <el-input-number v-model="form.sxf_zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr22"></el-input-number>
      </el-form-item>

      <el-form-item v-if="formEdit23"
                    prop="sxf_private_key"
                    label="随行付私钥"
      >
        <el-input v-model="form.sxf_private_key" :disabled="disabledStr23"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit24"
                    prop="sxf_mechanism_coding"
                    label="随行付机构编码"
      >
        <el-input v-model="form.sxf_mechanism_coding" :disabled="disabledStr24"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit25"
                    prop="ys_wx_rate"
                    label="微信利率"
      >
        <el-input-number v-model="form.ys_wx_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr25"></el-input-number>
      </el-form-item>

      <el-form-item v-if="formEdit26"
                    prop="ys_zfb_rate"
                    label="支付宝利率"
      >
        <el-input-number v-model="form.ys_zfb_rate" :min="0.00" :max="100" :step="0.01" :disabled="disabledStr26"></el-input-number>
      </el-form-item>

      <el-form-item v-if="formEdit27"
                    prop="ys_merchant_code"
                    label="商户编码"
      >
        <el-input v-model="form.ys_merchant_code" :disabled="disabledStr27"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit28"
                    prop="ys_key"
                    label="key密钥"
      >
        <el-input v-model="form.ys_key" :disabled="disabledStr28"></el-input>
      </el-form-item>

      <el-form-item v-if="formEdit29"
                    prop="ys_payment_type"
                    label="银盛支付类型"
      >
        <el-input v-model="form.ys_payment_type" :disabled="disabledStr29"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button @click="close">取消</el-button>
        <el-button @click="pzgl">配置</el-button>
        <el-button
          type="primary"
          :loading="loading"
          @click="saveUser"
          :disabled="disabledStr30"
        >保存</el-button>

      </el-form-item>
    </el-form>

  </el-dialog>

</template>
<script>
import * as agentService from '@/api/sys/agent'
import * as userService from '@/api/sys/user'
import util from '@/libs/util.js'
export default {
  name: 'payparameterEditForm',
  props: {
    agent: Object,
    accuseVisible: Boolean,
    value: Boolean
  },
  data () {
    return {
      imgUrl: process.env.VUE_APP_API + '/moblieapp/currencyUpload',
      radio: '0',
      fileList: [],
      formEdit1: true,
      accuseVisible2: true,
      formEdit2: true,
      loading: false,
      dialogVisible: false,
      form: {
        wx_appId: '',
        wx_mchId: '',
        wx_api_key: '',
        wx_appSecret: '',
        wx_certificate_path: '',
        wx_apiv3_key: '',
        wx_certificate: '',
        wx_certificate_name: '',
        zfb_appId: '',
        zfb_privateKey: '',
        zfb_publicKey: '',
        zfb_applet_key: '',
        zfb_applet_appid: '',
        zfb_pid: '',
        fy_private_key: '',
        fy_mechanism_coding: '',
        fy_order_code: '',
        sxf_private_key: '',
        sxf_mechanism_coding: '',
        ys_merchant_code: '',
        ys_key: '',
        ys_payment_type: ''
      },
      formEdit3: true,
      formEdit4: true,
      formEdit5: true,
      formEdit6: true,
      formEdit7: true,
      formEdit8: true,
      formEdit9: false,
      formEdit10: false,
      formEdit11: false,
      formEdit12: false,
      formEdit13: false,
      formEdit14: false,
      formEdit15: false,
      formEdit16: false,
      formEdit17: false,
      formEdit18: false,
      formEdit19: false,
      formEdit20: false,
      formEdit21: false,
      formEdit22: false,
      formEdit23: false,
      formEdit24: false,
      formEdit25: false,
      formEdit26: false,
      formEdit27: false,
      formEdit28: false,
      formEdit29: false,
      disabledStr1: true,
      disabledStr2: true,
      disabledStr3: true,
      disabledStr4: true,
      disabledStr5: true,
      disabledStr6: true,
      disabledStr7: true,
      disabledStr8: true,
      disabledStr9: true,
      disabledStr10: true,
      disabledStr11: true,
      disabledStr12: true,
      disabledStr13: true,
      disabledStr14: true,
      disabledStr15: true,
      disabledStr16: true,
      disabledStr17: true,
      disabledStr18: true,
      disabledStr19: true,
      disabledStr20: true,
      disabledStr21: true,
      disabledStr22: true,
      disabledStr23: true,
      disabledStr24: true,
      disabledStr25: true,
      disabledStr26: true,
      disabledStr27: true,
      disabledStr28: true,
      disabledStr29: true,
      disabledStr30: true
    }
  },
  watch: {
    value (val) {
      this.dialogVisible = val
    },
    accuseVisible (newValue, oldValue) {
      console.log('-----' + newValue)
      this.accuseVisible2 = newValue
    },

    dialogVisible (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    dialogOpen () {
      this.disabledStr1 = true
      this.disabledStr2 = true
      this.disabledStr3 = true
      this.disabledStr4 = true
      this.disabledStr5 = true
      this.disabledStr6 = true
      this.disabledStr7 = true
      this.disabledStr8 = true
      this.disabledStr9 = true
      this.disabledStr10 = true
      this.disabledStr11 = true
      this.disabledStr12 = true
      this.disabledStr13 = true
      this.disabledStr14 = true
      this.disabledStr15 = true
      this.disabledStr16 = true
      this.disabledStr17 = true
      this.disabledStr18 = true
      this.disabledStr19 = true
      this.disabledStr20 = true
      this.disabledStr21 = true
      this.disabledStr22 = true
      this.disabledStr23 = true
      this.disabledStr24 = true
      this.disabledStr25 = true
      this.disabledStr26 = true
      this.disabledStr27 = true
      this.disabledStr28 = true
      this.disabledStr29 = true
      this.disabledStr30 = true
      var formData4 = new FormData() // 声明一个FormData对象
      formData4.append('agentid', util.cookies.get('agentid'))
      agentService.getConfigureService(formData4).then(data => {
        if (data != null && data != '') {
          this.form.wx_appId = data.wx_appId
          this.form.wx_mchId = data.wx_mchId
          this.form.wx_api_key = data.wx_api_key
          this.form.wx_appSecret = data.wx_appSecret
          this.form.wx_certificate_path = data.wx_certificate_path
          this.form.wx_apiv3_key = data.wx_apiv3_key

          if (data.wx_certificate != null && data.wx_certificate != '' && data.wx_certificate != 'null') {
            this.fileList = [{ name: data.wx_certificate_name, nurl: 'https://xgkj-1304765860.cos.ap-shanghai.myqcloud.com/' + data.wx_certificate }]
            this.form.wx_certificate = data.wx_certificate
            this.form.wx_certificate_name = data.wx_certificate_name
          }

          this.form.zfb_appId = data.zfb_appId
          this.form.zfb_privateKey = data.zfb_privateKey
          this.form.zfb_publicKey = data.zfb_publicKey
          this.form.zfb_applet_key = data.zfb_applet_key
          this.form.zfb_applet_appid = data.zfb_applet_appid
          this.form.zfb_pid = data.zfb_pid
          this.form.fy_private_key = data.fy_private_key
          this.form.fy_mechanism_coding = data.fy_mechanism_coding
          this.form.fy_order_code = data.fy_order_code
          this.form.sxf_private_key = data.sxf_private_key
          this.form.sxf_mechanism_coding = data.sxf_mechanism_coding
          this.form.ys_merchant_code = data.ys_merchant_code
          this.form.ys_key = data.ys_key
          this.form.ys_payment_type = data.ys_payment_type
          if (data.wx_rate != null && data.wx_rate != '') {
            this.form.wx_rate = data.wx_rate
          }
          if (data.zfb_rate != null && data.zfb_rate != '') {
            this.form.zfb_rate = data.zfb_rate
          }
          if (data.fy_wx_rate != null && data.fy_wx_rate != '') {
            this.form.wx_rate = data.fy_wx_rate
          }
          if (data.fy_zfb_rate != null && data.fy_zfb_rate != '') {
            this.form.fy_zfb_rate = data.fy_zfb_rate
          }
          if (data.sxf_wx_rate != null && data.sxf_wx_rate != '') {
            this.form.sxf_wx_rate = data.sxf_wx_rate
          }
          if (data.sxf_zfb_rate != null && data.sxf_zfb_rate != '') {
            this.form.sxf_zfb_rate = data.sxf_zfb_rate
          }
          if (data.ys_wx_rate != null && data.ys_wx_rate != '') {
            this.form.ys_wx_rate = data.ys_wx_rate
          }
          if (data.ys_zfb_rate != null && data.ys_zfb_rate != '') {
            this.form.ys_zfb_rate = data.ys_zfb_rate
          }
        }
      })
    },
    // 点击文件列表中已上传的文件时的钩子
    handleRemove (file) {
      this.form.wx_certificate = ''
      this.form.wx_certificate_name = ''
      this.dialogVisible = true
    },
    // 上传文件之前的钩子
    handleBeforeUpload (file) {
      let isJPG = true
      // this.$message('上传模板只能是.jpg .jpeg .gif .png .bmp格式!');
      console.log('before')
      let size = file.size / 1024 / 1024 / 2
      if (size > 2) {
        this.$notify.warning({
          title: '警告',
          message: '文件大小必须小于2M'
        })
        isJPG = false
      }

      return isJPG // 返回false不会自动上传
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePictureCardPreview (file) {
      console.log('=======file.url==========' + file.url)
      this.form.wx_certificate = file.url
      this.form.wx_certificate_name = file.name
      this.dialogVisible = true
    },
    pzgl () {
      this.disabledStr1 = false
      this.disabledStr2 = false
      this.disabledStr3 = false
      this.disabledStr4 = false
      this.disabledStr5 = false
      this.disabledStr6 = false
      this.disabledStr7 = false
      this.disabledStr8 = false
      this.disabledStr9 = false
      this.disabledStr10 = false
      this.disabledStr11 = false
      this.disabledStr12 = false
      this.disabledStr13 = false
      this.disabledStr14 = false
      this.disabledStr15 = false
      this.disabledStr16 = false
      this.disabledStr17 = false
      this.disabledStr18 = false
      this.disabledStr19 = false
      this.disabledStr20 = false
      this.disabledStr21 = false
      this.disabledStr22 = false
      this.disabledStr23 = false
      this.disabledStr24 = false
      this.disabledStr25 = false
      this.disabledStr26 = false
      this.disabledStr27 = false
      this.disabledStr28 = false
      this.disabledStr29 = false
      this.disabledStr30 = false
    },
    changeHandler (val) {
      if (val == 0) {
        this.formEdit1 = true
        this.formEdit2 = true
        this.formEdit3 = true
        this.formEdit4 = true
        this.formEdit5 = true
        this.formEdit6 = true
        this.formEdit7 = true
        this.formEdit8 = true
        this.formEdit9 = false
        this.formEdit10 = false
        this.formEdit11 = false
        this.formEdit12 = false
        this.formEdit13 = false
        this.formEdit14 = false
        this.formEdit15 = false
        this.formEdit16 = false
        this.formEdit17 = false
        this.formEdit18 = false
        this.formEdit19 = false
        this.formEdit20 = false
        this.formEdit21 = false
        this.formEdit22 = false
        this.formEdit23 = false
        this.formEdit24 = false
        this.formEdit25 = false
        this.formEdit26 = false
        this.formEdit27 = false
        this.formEdit28 = false
        this.formEdit29 = false
      } else if (val == 1) {
        this.formEdit1 = false
        this.formEdit2 = false
        this.formEdit3 = false
        this.formEdit4 = false
        this.formEdit5 = false
        this.formEdit6 = false
        this.formEdit7 = false
        this.formEdit8 = false
        this.formEdit9 = true
        this.formEdit10 = true
        this.formEdit11 = true
        this.formEdit12 = true
        this.formEdit13 = true
        this.formEdit14 = true
        this.formEdit15 = true
        this.formEdit16 = false
        this.formEdit17 = false
        this.formEdit18 = false
        this.formEdit19 = false
        this.formEdit20 = false
        this.formEdit21 = false
        this.formEdit22 = false
        this.formEdit23 = false
        this.formEdit24 = false
        this.formEdit25 = false
        this.formEdit26 = false
        this.formEdit27 = false
        this.formEdit28 = false
        this.formEdit29 = false
      } else if (val == 2) {
        this.formEdit1 = false
        this.formEdit2 = false
        this.formEdit3 = false
        this.formEdit4 = false
        this.formEdit5 = false
        this.formEdit6 = false
        this.formEdit7 = false
        this.formEdit8 = false
        this.formEdit9 = false
        this.formEdit10 = false
        this.formEdit11 = false
        this.formEdit12 = false
        this.formEdit13 = false
        this.formEdit14 = false
        this.formEdit15 = false
        this.formEdit16 = true
        this.formEdit17 = true
        this.formEdit18 = true
        this.formEdit19 = true
        this.formEdit20 = true
        this.formEdit21 = false
        this.formEdit22 = false
        this.formEdit23 = false
        this.formEdit24 = false
        this.formEdit25 = false
        this.formEdit26 = false
        this.formEdit27 = false
        this.formEdit28 = false
        this.formEdit29 = false
      } else if (val == 3) {
        this.formEdit1 = false
        this.formEdit2 = false
        this.formEdit3 = false
        this.formEdit4 = false
        this.formEdit5 = false
        this.formEdit6 = false
        this.formEdit7 = false
        this.formEdit8 = false
        this.formEdit9 = false
        this.formEdit10 = false
        this.formEdit11 = false
        this.formEdit12 = false
        this.formEdit13 = false
        this.formEdit14 = false
        this.formEdit15 = false
        this.formEdit16 = false
        this.formEdit17 = false
        this.formEdit18 = false
        this.formEdit19 = false
        this.formEdit20 = false
        this.formEdit21 = true
        this.formEdit22 = true
        this.formEdit23 = true
        this.formEdit24 = true
        this.formEdit25 = false
        this.formEdit26 = false
        this.formEdit27 = false
        this.formEdit28 = false
        this.formEdit29 = false
      } else if (val == 4) {
        this.formEdit1 = false
        this.formEdit2 = false
        this.formEdit3 = false
        this.formEdit4 = false
        this.formEdit5 = false
        this.formEdit6 = false
        this.formEdit7 = false
        this.formEdit8 = false
        this.formEdit9 = false
        this.formEdit10 = false
        this.formEdit11 = false
        this.formEdit12 = false
        this.formEdit13 = false
        this.formEdit14 = false
        this.formEdit15 = false
        this.formEdit16 = false
        this.formEdit17 = false
        this.formEdit18 = false
        this.formEdit19 = false
        this.formEdit20 = false
        this.formEdit21 = false
        this.formEdit22 = false
        this.formEdit23 = false
        this.formEdit24 = false
        this.formEdit25 = true
        this.formEdit26 = true
        this.formEdit27 = true
        this.formEdit28 = true
        this.formEdit29 = true
      }
    },
    saveUser () {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          agentService.ServiceSaveConfigure({ ...this.form, agentid: util.cookies.get('agentid'), xt_id: util.cookies.get('xt_id') })
            .then(data => {
              this.loading = false
              this.dialogVisible = false
              this.$emit('submit')
            })
        } else {
          return false
        }
      })
    },
    close () {
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    }
  }
}
</script>
